var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:`badge badge-${_vm.color} mr-1`},[_vm._v(" "+_vm._s(_vm.label)+" "+_vm._s(_vm.value && _vm.value.toFixed(_vm.decimals))+_vm._s(_vm.unit)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }